import { FC } from 'react'
import { Skeleton, SkeletonProps } from 'antd'

interface SkeletonsProps {
  mode: 'LINE' | 'LINES' | 'LINES_WITH_IMAGE'
}

const skeletonConfigurations: Record<SkeletonsProps['mode'], SkeletonProps> = {
  LINE: { active: true, paragraph: { rows: 0 } },
  LINES: { active: true, paragraph: { rows: 4 } },
  LINES_WITH_IMAGE: { avatar: true, paragraph: { rows: 4 } }
}

const Skeletons: FC<SkeletonsProps> = ({ mode }) => {
  const props = skeletonConfigurations[mode]
  return <Skeleton {...props} />
}

export default Skeletons
